import { render, staticRenderFns } from "./pointAuctionDecoration.vue?vue&type=template&id=9d764a4c&scoped=true"
import script from "./pointAuctionDecoration.vue?vue&type=script&lang=js"
export * from "./pointAuctionDecoration.vue?vue&type=script&lang=js"
import style0 from "./pointAuctionDecoration.vue?vue&type=style&index=0&id=9d764a4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d764a4c",
  null
  
)

export default component.exports